$(function(){

  //メインビジュアルのスライダー
  illm.mainvisual.slider();

});

illm.mainvisual = {};

/*
 * メインビジュアルのスライダー
 */
illm.mainvisual.slider = function(){
  const slideAutoplay = Boolean($('#illm-slide_autoplay').attr('date-info'));//true
  const slideAutoplaySpeed = parseInt($('#illm-slide_autoplay_speed').attr('date-info'));//4000ms
  const slideSpeed = parseInt($('#illm-slide_speed').attr('date-info'));//600ms
  const slideArrow = Boolean($('#illm-slide_arrow').attr('date-info'));//true
  const slideDot = Boolean($('#illm-slide_dot').attr('date-info'));//true
  
  $( '.illm-mvslider' ).slick({
    autoplay: slideAutoplay,
    autoplaySpeed: slideAutoplaySpeed,
    speed: slideSpeed,
    arrows: slideArrow,
    dots: slideDot,
    lazyLoad: 'ondemand',
    infinite: true,
    centerMode: false,
    centerPadding: '0px',
    slidesToShow: 1
  }).css( 'visibility', 'visible' );

}